// extracted by mini-css-extract-plugin
module.exports = {"carouselImg":"carouselImg_GGSnK93I"};